/*jshint esversion: 8 */
//{/* use this to comment inside jsx*/}
import './styles/home.css';
import './styles/liquidity.css';
import Image from 'react-bootstrap/Image';
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import ab from './pix/mail.png';
import mp from './pix/arrow-right-1.png';
import l4 from './pix/l4.svg';
import st from './pix/structure.svg';
import dollar from './pix/dollar.svg';
import geo from './pix/geo.svg';
import trans from './pix/trans.png';
import prof from './pix/prof.svg';
import port from './pix/port.svg';
import lend from './pix/lend.jpg';
import reach from './util/home/Global-Reach-scaled.jpg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';


{/**logo should be png file, have a transparent background */}

function Liquidity () {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [aboutUsHover, setAboutUsHover] = useState(false);
    const [strategiesHover, setStrategiesHover] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        // Cleanup: make sure class is removed if the component unmounts
        // while the menu is open (e.g. route change).
        return () => {
            if (menuOpen) document.body.classList.remove("menu-open");
        };
    }, [menuOpen]);

    // Simple toggle for the hamburger button — no more manual DOM calls here.
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    // Dedicated close function used by the X button, overlay, and nav items.
    const closeMenu = () => {
        setMenuOpen(false);
    };
    // Add these states for mobile dropdowns (separate from desktop)
    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileStrategiesOpen, setMobileStrategiesOpen] = useState(false);
    // New State for Scroll Effect
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // If user scrolls more than 150px, trigger the fixed state
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
     <div class=''>

    <Navbar id='nav-ham' expanded={expanded} onToggle={() => setExpanded(!expanded)} collapseOnSelect expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'navbar-fixed-reveal' : ''}`} variant="light">
  <Container className="d-flex w-100 align-items-center justify-content-between" id='nav-con-f'>
  <Navbar.Brand href="/"><Image
                src={l4}
                id='nav-img-og'
                alt="shereen Logo"
            /></Navbar.Brand>

{/* Custom Hamburger Button for mobile */}
  <button
  id='burg'
  className={`hamburger-button ${menuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Menu"
>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
</button>

  <Navbar.Collapse id="responsive-navbar-nav" style = {{}}>
    <Nav className="ms-auto align-items-center"  style = {{marginRight: '-10%'}}  >
    <NavDropdown
                    title={
                        <span  onMouseEnter={() => setAboutUsHover(true)} onClick={(e) => {e.preventDefault(); navigate('/abt')}}
                        onMouseLeave={() => setAboutUsHover(false)} className="custom-span">
                            About Us <FontAwesomeIcon icon={faChevronDown}  className="dropdown-arrow ms-2" style = {{fontSize: '18px'}}/>
                        </span>
                    }
                    id="aboutus-dropdown"
                    className="nav-dropdown-custom"
                    show={aboutUsHover}
                >
                    <NavDropdown.Item onClick={() => navigate('/corporate-governance')}>
                        Corporate Governance
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/chairmans-message')}>
                        Chairman's Message
                    </NavDropdown.Item>
                </NavDropdown>

      {/**SECOND NAV HOV */}
    <NavDropdown
    title={
        <span  onMouseEnter={() => setStrategiesHover(true)}
                onMouseLeave={() => setStrategiesHover(false)} className="custom-span">
            Our Strategies <FontAwesomeIcon icon={faChevronDown} style = {{fontSize: '18px'}} className="dropdown-arrow ms-2" />
        </span>
    }

    id="strategies-dropdown"
    className="nav-dropdown-custom"
    show={strategiesHover}
>
    <NavDropdown.Item onClick={() => navigate('/opportunities')}>
        Opportunistic Investing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/lending')}>
        Direct Lending
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/liquidity-solutions')}>
        Fund Liquidity Solutions
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/corporate-finance')}>
        Corporate Financing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/estate')}>
        Real Estate
    </NavDropdown.Item>
</NavDropdown>
      <Nav.Link id="nav-lks" onClick={() => navigate('/team')}>Our Team</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/careers')}>Careers</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/contact-us')}>Contact Us</Nav.Link>

    </Nav>

  </Navbar.Collapse>
  </Container>
</Navbar>

{/* ====================== CUSTOM MOBILE SLIDE MENU ====================== */}
{/* ====================== FULL SCREEN MOBILE SLIDE MENU ====================== */}
<div className={`mobile-menu-fullscreen ${menuOpen ? 'active' : ''}`}>
  <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}></div>
  <div className="mobile-menu-container">
    <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>×</button>

    <div className="mobile-menu-content">
      <Nav className="flex-column mobile-nav-stack">

        {/* About Us with Dropdown */}
        <div className="mobile-dropdown-wrapper">
        <div className="mobile-menu-item" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <span

            onClick={() => { navigate('/abt'); setMenuOpen(false); }}
            style={{ flex: 1, cursor: 'pointer' }}
        >
            About Us
        </span>
        <span
            className={`dropdown-arrow ${mobileAboutOpen ? 'open' : ''}`}
            onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
            style={{ cursor: 'pointer', marginLeft:'20px'}}
        >
            ▼
        </span>
        </div>
        {mobileAboutOpen && (
        <div className="mobile-sub-menu">
            <div className="sub-item" onClick={() => { navigate('/corporate-governance'); setMenuOpen(false); }}>
            Corporate Governance
            </div>
            <div className="sub-item" onClick={() => { navigate('/chairmans-message'); setMenuOpen(false); }}>
            Chairman's Message
            </div>
        </div>
        )}
        </div>


        {/* Our Strategies with Dropdown */}
        <div className="mobile-dropdown-wrapper">
          <div
          className="mobile-menu-item"
          onClick={() => setMobileStrategiesOpen(!mobileStrategiesOpen)}
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span style={{ flex: 1, cursor: 'pointer' }}>
            Our Strategies
          </span>
          <span className={`dropdown-arrow ${mobileStrategiesOpen ? 'open' : ''}`}>▼</span>
        </div>
          {mobileStrategiesOpen && (
            <div className="mobile-sub-menu">
              <div className="sub-item" onClick={() => { navigate('/opportunities'); setMenuOpen(false); }}>
                Opportunistic Investing
              </div>
              <div className="sub-item" onClick={() => { navigate('/lending'); setMenuOpen(false); }}>
                Direct Lending
              </div>
              <div className="sub-item" onClick={() => { navigate('/liquidity-solutions'); setMenuOpen(false); }}>
                Fund Liquidity Solutions
              </div>
              <div className="sub-item" onClick={() => { navigate('/corporate-finance'); setMenuOpen(false); }}>
                Corporate Financing
              </div>
              <div className="sub-item" onClick={() => { navigate('/estate'); setMenuOpen(false); }}>
                Real Estate
              </div>
            </div>
          )}
        </div>

        {/* Our Team */}
        <div className="mobile-menu-item" onClick={() => { navigate('/team'); setMenuOpen(false); }}>
          Our Team
        </div>

        {/* Careers */}
        <div className="mobile-menu-item" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
          Careers
        </div>

        {/* Contact Us */}
        <div className="mobile-menu-item no-border" onClick={() => { navigate('/contact-us'); setMenuOpen(false); }}>
          Contact Us
        </div>

      </Nav>
    </div>
  </div>
</div>

      {/**hero section start*/}
      <Container fluid className="px-0" style={{
        marginTop: '6%',
        paddingTop: '80px',
        paddingBottom: '80px',
        backgroundColor: '#CD1C18',
        color: '#ffffff',
        overflow: 'visible', // Allows the image to overlap the bottom edge
        position: 'relative',
        zIndex: 1
    }}>
            <Row    style = {{paddingLeft: '3%', paddingRight: '3%',}}>
            <Col md = {6} xs={12} id="career-col-lq" >
            <Row id='career-txt'><span id='career-bar-f'></span> Fund Liquidity Solutions</Row>
            <Row id="ct">Helping Investors Unlock Captive Portfolio Value through NAV Financings</Row>
          </Col>
          <Col id='col-bar' ></Col>
            </Row>
       </Container>
       {/**hero section end*/}

       <Container  >
        <Row   id=''>
            <Col id = 'balance-col-lq' md = {6} xs={12}>Shereen’s Fund Liquidity Solutions Group provides bespoke NAV loans to private equity funds and other asset vehicles seeking flexible capital to support underlying portfolio companies, pursue accretive acquisitions, provide liquidity to investors and address opportunistic portfolio management needs.</Col>

        </Row>
       </Container>

       {/**secured */}
       <Container  fluid style = {{backgroundColor: '#f8f8f8'}}>
                <Row  id='tailored-row-lq'>
                    <Row  id='flexible-row-lnd'>Thinking Outside the Box to Secured Lending</Row>
                    <Row>
                      <Col  id='fortress-col-ln' md={5} xs = {12}>
                        <Row   id='fortress-col-txt'>We partner with managers to provide flexible, non-dilutive Net Asset Value (NAV) based financings that can be utilized for a wide range of growth focused and defensive purposes. As market leaders, we have closed over 75 NAV loans with Private Equity, Growth, Venture, Real Estate, Credit, Infrastructure managers, and multi-asset class portfolios, as well as Family Offices, Holding Companies and Private Investment Companies. We are active across a broad range of industries and geographies.</Row>
                        <Row id='fortress-col-txt'>The careful consideration and conservative approach that we apply to each and every loan, and our policy of brokering riskier loans to other companies has opened up new income streams and helped diversify our product offering, meaning more secure investments for our loyal clients.</Row>
                        <Row id='fortress-col-txt'>We take a collaborative approach with managers, structuring creative facilities that help borrowers achieve their goals while understanding that the underlying collateral and use of proceeds are unique in every loan.</Row>

                      </Col>
                      <Col id='fortress-col-lq' md={5} xs = {12}>
                        <Row id='fortress-col-txt'>At Shereen Investment Company LLC, we prioritize fortress capital and enduring partnerships in our direct private equity endeavors. We invest strategically in carefully selected companies, aiming to create lasting prosperity by going beyond just financial contributions.</Row>
                        <Row id='fortress-col-txt'>We recognize the power of collaboration. By providing strategic guidance and operational support to our portfolio companies, we work alongside them to unlock their full potential. Additionally, we capitalize on synergies with other investment companies, fostering meaningful partnerships that drive value creation.</Row>
                        <Row id='fortress-col-txt'>At Shereen Investment Company LLC, we leverage our expertise by partnering with top-tier managers. We strategically invest through diligently selected funds targeting venture capital, growth capital, and expansion capital strategies. Our focus on developed markets ensures access to established investment opportunities while maintaining a focus on attractive risk-adjusted returns.</Row>
                      </Col>
                    </Row>
                </Row>
       </Container>

    {/**parameters */}
      <Container fluid id='invest-container-l'>
            <Row   id='invest-params-txt-ln' xs={12} >Investment Parameters</Row>
            <Row >

                     <Col md = {3} xs={12} id='invest-cols'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '20%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {dollar} style={{ height: '64px', width: 'auto', marginLeft: '5%'}}/>
                <Card.Title id='card-ld-ttl'>Investment Size</Card.Title>
                <Card.Text  id='card-ld-tx'>
                        $25mm - $250+mm
                    </Card.Text>
                <Card.Text id='card-ld-ttl'>Term</Card.Text>
                <Card.Text  id='card-ld-tx'>
                <ul>
                            <li>1 – 5 Years</li>
                            <li>Flexible Interest: PIK or Cash</li>
                            <li>Fully drawn or delayed draw</li>

                    </ul>
                    </Card.Text>
                    <Card.Text id='card-ld-ttl'>
                        Geography
                    </Card.Text>
                    <Card.Text  style={{marginTop: '2%', fontSize: '22px', fontHeight: '34px', fontFamily: 'Lato', fontWeight: '370', color: '#222b2f'}}>
                        Americas, Europe & Asia
                    </Card.Text>
                </Card.Body>
                </Card>
                    </Col>



                <Col md = {3} xs={12} id='invest-cols'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '44%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {st} style={{ height: 'auto', width: 'auto', marginLeft: '1%'}}/>
                <Card.Title id='card-ld-ttl'>Structures</Card.Title>
                <Card.Text id='card-ld-tx'>
                <ul>
                            <li>Loan to Fund</li>
                            <li>Preferred Equity</li>
                            <li>Loan to a portfolio company with fund Guaranty</li>
                            <li>Loan to General Partner and Management Company</li>

                    </ul>
                    </Card.Text>

                </Card.Body>
                </Card>
            </Col>

                <Col md = {3} xs={12} id='invest-cols'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '62%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {port} style={{ height: '64px', width: '64px', marginLeft: '1%'}}/>
                <Card.Title id='card-ld-ttl'>Portfolio Characteristics</Card.Title>
                <Card.Text  id='card-ld-tx'>
                <ul>
                            <li>Two or more remaining investments</li>
                            <li>Minority or majority shareholding</li>
                            <li>Debt or equity positions</li>

                    </ul>
                    </Card.Text>

                </Card.Body>
                </Card>
            </Col>

                <Col md = {3} xs={12} id='invest-cols'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '4%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {prof} style={{ height: '64px', width: '64px', marginLeft: '1%'}}/>
                <Card.Title id='card-ld-ttl'>Borrower Profile</Card.Title>
                <Card.Text  id='card-ld-tx'>
                <ul>
                            <li>Buyout, Growth Equity, Real Estate, Infrastructure, Venture Capital, and Credit Funds</li>
                            <li>Traditional fund structures, evergreen vehicle, trust companies, family offices, holding companies, and private investment companies</li>

                    </ul>
                    </Card.Text>

                </Card.Body>
                </Card>
            </Col>

            </Row>
      </Container>

      {/**investment type*/}

      <Container fluid id='bridge-container'>
        <Row  id='bridge-industry-txt'>Use of Proceeds</Row>
        <Row   className='gx-5' style={{fontFamily: 'Lato', fontWeight: '300', fontSize: '20px', lineHeight: '32px', marginTop: '4%', color: '#ffffff'}}>
            <Col  md = {4} xs={12}><span style = {{fontWeight: '400', fontSize: '25px', marginLeft: '4%'}}>Accretive Follow-Ons</span>
            <ul style = {{marginTop: '8%', fontFamily: 'Lato-light'}}>
                <li>Complete new platform acquisitions</li>
                <li>Provide growth capital</li>
                <li>Participate in pre-IPO rounds</li>
                <li>Finance accretive acquisitions</li>
                <li>Buy out co-investors</li>
            </ul></Col>
            <Col md = {4} xs={12}><span style = {{fontWeight: '400', fontSize: '25px', marginLeft: '4%'}}>Protective Follow-Ons</span>
            <ul style = {{marginTop: '8%', fontFamily: 'Lato-light'}}>
            <li>Participate in punitive pay-to-play rounds</li>
            <li>Avoid or cure covenant breaches</li>
            <li>Balance sheet clean-up or refinance</li>
            <li>Weather business cycles</li>
        </ul></Col>
            <Col><span style = {{fontWeight: '400', fontSize: '25px', marginLeft: '4%'}}>Secondary Transactions</span>
            <ul style = {{marginTop: '8%', fontFamily: 'Lato-light'}}>
            <li>Bridge to a continuation vehicle</li>
            <li>Support leave behind assets post continuation vehicle process</li>
            <li>Improve IRR</li>
            <li>Bridge continuation vehicle fund closing</li>

        </ul></Col>
        </Row>

        <Row   className='gx-5' style={{fontFamily: 'Lato', fontWeight: '300', fontSize: '20px', lineHeight: '32px', marginTop: '7%', color: '#ffffff'}}>
            <Col md = {4} xs={12}><span style = {{fontWeight: '400', fontSize: '25px', marginLeft: '4%'}}>Provide Liquidity to LPs</span>
            <ul style = {{marginTop: '8%', fontFamily: 'Lato-light'}}>
                <li>Provide partial liquidity to all LPs</li>
                <ul id = 'dash'><li >Enhance DPI/TVPI, rebalance outsized positions, other investment needs</li></ul>
                <li>Provide full liquidity to a subset of LPs</li>
                <ul id = 'dash'><li >Fund repurchases stakes from selling LPs directly</li></ul>
                <ul id = 'dash'><li >Remaining LPs and GP benefit as the value of underlying assets continue to rise.</li></ul>
            </ul></Col>
            <Col md = {4} xs={12}><span style = {{fontWeight: '400', fontSize: '25px', marginLeft: '4%'}}>Special Situations</span>
            <ul style = {{marginTop: '8%', fontFamily: 'Lato-light'}}>
            <li>Debt for credit-challenged porlio company with portfolio providing credit enhancement</li>
            <li>Build Control Positions</li>
            <li>Warehouse co-investment opportunities</li>
            <li>Bridge between fundraises</li>
        </ul></Col>
            <Col md = {4} xs={12}><span style = {{fontWeight: '400', fontSize: '25px', marginLeft: '4%'}}>Management Company</span>
            <ul style = {{marginTop: '8%', fontFamily: 'Lato-light'}}>
            <li>Seed new strategy</li>
            <li>Fund GP commitments</li>
            <li>Fund succession planning</li>


        </ul></Col>
        </Row>
      </Container>

      {/**end reach */}
      <Container  fluid className="px-0">
      <Row   style = {{marginTop: '1%'}}>
            {/* Card 1: Seeking Capital */}
            <Col lg={6} xs={12}>
                <Card
                    className="cta-card"
                    style={{
                        backgroundColor: '#24325B',
                        borderRadius: '0',
                        border: 'none',
                        height: '100%'
                    }}
                >
                    <Card.Body className="text-center py-5 px-4 px-md-5">
                        <Image src={ab} style={{ height: '32px' }} alt="mail" />

                        <h2 style={{
                            fontFamily: 'rufinaalt01',
                            fontWeight: '400',
                            fontSize: 'clamp(28px, 5.5vw, 48px)',
                            lineHeight: '1.15',
                            color: '#ffffff',
                            marginTop: '28px'
                        }}>
                            Interested in Seeking Capital
                        </h2>

                        <p style={{
                            fontFamily: 'Lato',
                            fontWeight: '400',
                            fontSize: 'clamp(18px, 4vw, 24px)',
                            lineHeight: '1.45',
                            color: '#ffffff',
                            maxWidth: '580px',
                            margin: '24px auto 0'
                        }}>
                            Contact us to learn how we apply creativity and flexibility to our capital solutions.
                        </p>

                        <div style={{ marginTop: '45px' }}>
                            <a
                                className="box"
                                href=""
                                onClick={() => navigate('/contact-us')}
                                style={{
                                    border: '1px solid #f7f5f0',
                                    padding: '18px 24px',
                                    display: 'inline-block',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.4s ease'
                                }}
                            >
                                <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                            </a>
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            {/* Card 2: Join Our Team */}
            <Col lg={6} xs={12}>
                <Card
                    className="cta-card"
                    style={{
                        backgroundColor: '#CD1C18',
                        borderRadius: '0',
                        border: 'none',
                        height: '100%'
                    }}
                >
                    <Card.Body className="text-center py-5 px-4 px-md-5">
                        <Image src={ab} style={{ height: '32px' }} alt="mail" />

                        <h2 style={{
                            fontFamily: 'rufinaalt01',
                            fontWeight: '400',
                            fontSize: 'clamp(28px, 5.5vw, 48px)',
                            lineHeight: '1.15',
                            color: '#ffffff',
                            marginTop: '28px'
                        }}>
                            Join Our Team
                        </h2>

                        <p style={{
                            fontFamily: 'Lato',
                            fontWeight: '400',
                            fontSize: 'clamp(18px, 4vw, 24px)',
                            lineHeight: '1.45',
                            color: '#ffffff',
                            maxWidth: '580px',
                            margin: '24px auto 0'
                        }}>
                            Strong partnerships with customers start with the right colleagues.
                        </p>

                        <div style={{ marginTop: '45px' }}>
                            <a
                                className="box"
                                href=""
                                onClick={() => navigate('/careers')}
                                style={{
                                    border: '1px solid #f7f5f0',
                                    padding: '18px 24px',
                                    display: 'inline-block',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.4s ease'
                                }}
                            >
                                <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                            </a>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
              </Row>
          </Container>
            {/**footer section */}
            <Container  fluid style ={{backgroundColor: '#efefef', fontFamily: 'Lato',  paddingBottom: '10px'}}> {/**marginRight: '2%' */}


            <Row id='ft-txt'> © Copyright 2026 Shereen Investment Company LLC</Row>
                                    <Row id= 'last-rw' className='d-md-none m-0 p-0'>
            <Col id='linkd' xs={12} onClick={() => navigate('/')}><FontAwesomeIcon icon={faLinkedin} className="me-2" /></Col>
                  </Row>




    </Container>

            {/*the below div is last div/ function component div*/}
          </div>
    )
}

export default Liquidity;
